import { CUSTOM_GROUP_NAMES, EVENT_NAMES, TABLE_ACTIONS } from "./types/enums";
import { ResourceEventData } from "./types/interfaces";
import { useSignalREvent } from "./useSignalREvent";
import { useSignalRGroups } from "./useSignalRGroups";

export const useSignalRForBgActions = (
    id: string | null,
    callback: (data: ResourceEventData) => void
) => {
    const isIdNotNull = id !== null;

    const eventName = isIdNotNull
        ? `${EVENT_NAMES.BackgroundAction}_${TABLE_ACTIONS.Updating}`
        : undefined;

    const groups = isIdNotNull
        ? [`${CUSTOM_GROUP_NAMES.BackgroundActions}.${id}`]
        : [];

    useSignalREvent<ResourceEventData>(eventName, data => callback(data));
    useSignalRGroups(groups);
};
